.ActionContainer
    position: absolute
    bottom: 10px
    left: 10px
    right: 10px
    height: 60px
    background: rgba($globalCartColorsStatusBar, 0.75)
    border-radius: $globalButtonRounding
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    box-sizing: border-box
    z-index: $indexCart

.Blurred
    position: absolute
    bottom: 0
    left: 0
    right: 0
    height: 110px
    background: rgb($globalSettingsStrokePrimary)
    z-index: $indexCart - 1
    -webkit-mask-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))
    pointer-events: none

.ButtonContainer
    height: 100%
    max-width: 40%
    position: relative
    display: flex
    align-items: center
    margin: 0 10px

.CartContainer
    display: flex
    flex-direction: row
    flex: 1
    align-items: center

@media #{$tablet}
    .ActionContainer
        left: 20px
        right: 20px
        bottom: 20px
